<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="field_book_no">Field Book No. <span class="c-required">*</span></label>
                <input v-model="search_data.field_book_no" v-validate="{ required: true }" type="text" class="form-control form-control-sm" placeholder="Search by field book no" id="field_book_no"/>
                <div class="invalid-feedback">Field book no. is required</div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="c_mouza_id">Mouza <span class="c-required">*</span></label>
                <select v-model="search_data.c_mouza_id" v-validate="{ required: true }" class="form-control form-control-sm" name="c_mouza_id" id="c_mouza_id">
                  <option selected :value="''">Select a Mouza</option>
                  <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{
                      mouza.id}} : {{ mouza.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">Mouza is required</div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="c_village_id">Village <span class="c-required">*</span></label>
                <select v-model="search_data.c_village_id" v-validate="{ required: true }" class="form-control form-control-sm" name="c_village_id" id="c_village_id">
                  <option selected :value="''">Select a Village</option>
                  <option v-for="(village, index) in villages" :key="index" :value="village.id">{{village.id}} : {{ village.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">Village is required</div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3 mt-2">
                <label class="col-form-label col-form-label-sm" style="margin-top: 19px"></label>
                <button class="btn btn-success btn-sm mt-2" @click.prevent="search">Search</button>
              </div>
            </div>
          </form>
        </b-card>

        <b-card>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Field Book</th>
                <th>Book Sub no.</th>
                <th>Name Bn</th>
                <th>Father`s Name Bn</th>
                <th>Village</th>
                <th>Mouza</th>
                <th>Status</th>
                <th>Name</th>
                <th>Rep Name</th>
                <th>Batch</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(field_book, index) in field_books" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ field_book.field_book_no }}</td>
                <td>{{ field_book.filed_book_sub_no }}</td>
                <td>{{ field_book.name_bn }}</td>
                <td>{{ field_book.father_name_bn }}</td>
                <td>{{ field_book.village ? field_book.village.desc : ''}} </td>
                <td>{{ field_book.mouza ? field_book.mouza.desc : ''}} </td>
                <td>
                  <span class="custom-label custom-label-danger" v-if="field_book.status_id == 1">Locked</span>
                  <span  v-if="field_book.status_id == 2" >Unlock</span>
                </td>
                <td>{{ field_book.trainees[0] ? field_book.trainees[0].name : '' }} </td>
                <td>{{ field_book.trainees[0] ? field_book.trainees[0].rep_name : '' }} </td>
                <td>{{ field_book.trainees[0] ? field_book.trainees[0].desc  : '' }} | Batch No: {{ field_book.trainees[0] ? field_book.trainees[0].batch_no  : '' }} </td>
                <td>
                  <a  href="javascript:void(0);"
                     class="action-icon" title="Add Field Book" @click="onAdd(field_book)">
                    <i class="mdi mdi-plus addButton"></i>
                  </a>
                  <a href="javascript:void(0);"
                     class="action-icon" title="View Field Book" @click="viewFieldBook(field_book)">
                    <i class="mdi mdi-account-card-details viewColor"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
            <h5 class="text-center text-secondary" v-if="field_books.length === 0 || !flag">
              No Data Found
            </h5>
          </div>
        </b-card>
        <b-card v-if="add_field_books.length > 0">
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Field Book</th>
                <th>Book Sub no.</th>
                <th>Name Bn</th>
                <th>Father`s Name Bn</th>
                <th>Village</th>
                <th>Mouza</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(add_field_book, index) in add_field_books" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ add_field_book.field_book_no }}</td>
                <td>{{ add_field_book.filed_book_sub_no }}</td>
                <td>{{ add_field_book.name_bn }}</td>
                <td>{{ add_field_book.father_name_bn }}</td>
                <td>{{ add_field_book.village ? add_field_book.village.desc : ''}} </td>
                <td>{{ add_field_book.mouza ? add_field_book.mouza.desc : ''}} </td>
                <td>{{ add_field_book.reference_book_type ? add_field_book.reference_book_type.desc : '' }} </td>
                <td>
                  <span class="custom-label custom-label-danger" v-if="add_field_book.status_id == 1">Locked</span>
                  <span  v-if="add_field_book.status_id == 2" >Unlock</span>
                </td>
                <td>
                  <b-button
                      variant="danger"
                      class="btn btn-warning btn-xs waves-effect waves-light"
                      @click.prevent="softDelete(index)">
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <button class="btn btn-success btn-sm mt-2" @click.prevent="save">Save</button>
        </b-card>
      </div>
    </div>
    <view-modal
        :field_book="field_book"
    ></view-modal>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import viewModal from './modal/viewModal'
import moment from "moment";

export default {
  page: {
    title: "List of Field Book",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, viewModal},
  data() {
    return {
      title: "List of Field Book",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "List of Field Book",
          active: true
        }
      ],
      search_data: {
        field_book_no: '',
        c_mouza_id: '',
        c_village_id: '',
      },
      mouzas: [],
      villages: [],
      add_field_books: [],
      flag: false,
      loader: false,
      field_books: {},
      field_book: {},
      field_book_id: {},
      current_date: '',
    };
  },

  mounted() {
    this.getCodes();
    this.checkCurrentDate();
  },
  methods: {
    checkCurrentDate() {
      this.current_date = moment().format("YYYY-MM-DD");
    },
    getCodes() {
      http.get("api/field-book/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.mouzas = data.mouzas;
          this.villages = data.villages;
        }
      });
    },
    search() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.flag = true
          http.post("api/field-book/group/search", this.search_data).then(response => {
            if (!response.error) {
              this.flag = true;
              this.field_books = response.data.field_books;
            }
          });
        }
      });
    },
    onAdd(field_book) {
      if (confirm("Do you really want to add?")) {
        if (field_book != null){
          this.add_field_books.push(field_book);
        }
        this.field_books = []
      }
    },
    softDelete(index){
      this.add_field_books.splice(index, 1)
    },
    save() {
      http.post("api/field-book/group/store", this.add_field_books).then(response => {
        this.$bvToast.toast(response.data.message, {
          title: "Success",
          autoHideDelay: 5000,
          variant: "success"
        });
        this.field_books = []
        this.add_field_books = []
      });
    },
    viewFieldBook(field_book){
      this.field_book = {};
      this.field_book = field_book;
      this.$root.$emit("bv::show::modal", "field-book-view-modal");
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    },
    // villages() {
    //   const c_mouza_id  = this.search_data.c_mouza_id
    //   if(c_mouza_id){
    //     return this.all_villages.filter(x => x.c_mouza_id === c_mouza_id)
    //   }
    //   return this.all_villages;
    //
    // },
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
